import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import ImagenThankYou from "../../../../assets/CitasServicio/images/thankyou@2x.png"
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
    useParams,
} from "react-router-dom";

import {
    reiniciarStateAction
}   from "../../../../actions/citasServicioActions";

import { useDispatch }  from "react-redux";

import ROUTES from "../../../../utilities/Routes"

const ThankYou = () => {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const { concesionaria } = useParams();

    const reiniciarForm = () => {
        if(concesionaria === undefined || concesionaria === null || concesionaria === ""){
            navigate(ROUTES.CITASSERVICIOEMPTY);
        } else {
            navigate(ROUTES.CITASSERVICIOEMPTY + "/" + concesionaria);
        }
    }

    useEffect(() => {
        dispatch(reiniciarStateAction());
    }, [dispatch]);
    
    
    return (
        <>
            <div className="container citas-servicio">
                <div className="row">
                    <div className="col-12 col-md-6 text-center mt-5">
                        <LazyLoadImage
                            alt="citas_servicio_ty"
                            className="w-100"
                            src={ImagenThankYou}
                        />
                    </div>
                    <div className="col-12 col-md-6 text-left mt-5 ps-2 ps-md-4 d-vertical-center mobile-center">
                        <div>
                            <h2>Gracias por tu interés</h2>
                            <p>
                                En breve un asesor se contactará contigo.
                            </p>
                        </div>
                    </div>

                    <div className="col-12 mt-5 mb-5 text-center">
                        <button 
                            className="button-enviar" 
                            onClick={() => reiniciarForm()}
                        >
                            Finalizar
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ThankYou;